import { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { useApolloClients } from "~/components/ApolloClients";
import { GET_INTERVIEW_TRANSCRIPT } from "./operations";
import { toTranscriptDisplay } from "../mappers";
import type { TranscriptDisplay } from "../types";

export function useTranscript(interviewId: string | null) {
  const { federationGatewayClient } = useApolloClients();

  const { data, loading, error, refetch, startPolling, stopPolling } = useQuery(
    GET_INTERVIEW_TRANSCRIPT,
    {
      client: federationGatewayClient,
      variables: { interviewId },
      skip: !interviewId,
      fetchPolicy: "cache-and-network",
    },
  );

  const raw = data?.interviewTranscript;
  const transcript: TranscriptDisplay | null = raw
    ? toTranscriptDisplay(raw)
    : null;

  // Both the AI scorecard analysis and the transcript summary run in background
  // workers, so poll while EITHER is GENERATING and stop once both have landed on
  // COMPLETE / FAILED.
  const isGenerating =
    transcript?.aiAnalysisStatus === "GENERATING" ||
    transcript?.summaryStatus === "GENERATING";
  useEffect(() => {
    if (isGenerating) {
      startPolling(4000);
    } else {
      stopPolling();
    }
    return () => stopPolling();
  }, [isGenerating, startPolling, stopPolling]);

  return { transcript, loading, error, refetch };
}
